export function selectUpsellItems({
  responses,
  cartProductIds = [],
  cartProductCount = 0,
  maxProducts = 4,
  hideThreshold = 3,
}) {
  if (cartProductCount >= hideThreshold) return [];

  const seen = new Set();
  return (responses || [])
    .flatMap(resp => resp?.data || [])
    .filter(product => {
      const productId = product?.shopifyData?.variants?.[0]?.product_id;
      const key = product?.slug || productId;
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return !productId || !cartProductIds.includes(String(productId));
    })
    .slice(0, maxProducts);
}

export default selectUpsellItems;
